<template>
  <div class="container-lg mobile-padding">
    <section id="sticky-header">
      <nav class="flex-row hotels-header">
        <div class="text-start col">{{ translations.property?.[languageEnUk] ?? 'Property' }}</div>
        <div class="text-end col">{{ translations.nightly_rate?.[languageEnUk]?.replace('[[currency]]', currency) ?? 'Nightly Rate^ (' + currency + ')' }}</div>
      </nav>
    </section>
    <!-- /Header for the hotels, sticky -->


    <!-- IF this page has an highlighted hotel, show it here -->
    <section id="highlighted-hotel" v-if="selectedHotel" :class="selectedHotel && !selectedHotel.actual ? 'no-actual' : ''">
      <hotel :item="selectedHotel" @click="moreBooking(false, selectedHotel)" :currency="currency" :checkin="checkin" :checkout="checkout"></hotel>
    </section>
    <!-- /IF this page has an highlighted hotel, show it here -->


    <!-- IF an highlighted hotel is visible, this text should be visible too -->
    <section id="highlighted-hotel-option" v-if="selectedHotel">
      <a href="" class="highlighted-text" @click.prevent="moreBooking">

        {{ translations.maps?.[languageEnUk] ?? 'Maps' }} | {{ translations.photos?.[languageEnUk] ?? 'Photos' }} |  {{ translations.deals?.[languageEnUk] ?? 'Deals' }}
      </a>
    </section>
    <!-- /IF an highlighted hotel is visixble, this text should be visible too -->


    <!-- Text, only visible IF an highlighted hotel is visible -->
    <section id="hotels-near" v-if="selectedHotel">
      <div class="hotels-near">{{ translations.hotels_near?.[languageEnUk] ?? 'Hotels near' }} {{ selectedHotel.name }}, {{ selectedHotel.city }}</div>
    </section>
    <!-- /Text, only visible IF an highlighted hotel is visible -->


    <!-- Hotels -->
    <section id="hotels">
      <ul class="hotel-list">
        <li class="hotel-list-item" v-for="(item, index) in content" :class="item && !item.actual ? 'no-actual' : ''">
          <hotel :item="item" @click="moreBooking(false, item)" :currency="currency" :index="index" :checkin="checkin" :checkout="checkout"></hotel>
        </li>
      </ul>
    </section>
    <!-- Hotels -->
    <section id="hotels-more" v-if="cityName" @click="moreBooking" style="cursor: pointer;">
      <div class="hotels-more">
        <div class="hotels-more-top">More accommodation in {{ cityName }} <i class="bi bi-chevron-right"></i></div>
        <div class="hotels-more-bottom">Resorts, hotel, apartments and more</div>
      </div>
    </section>
    <!-- /Link for more accomedations -->
    <section id="hotels-reference" class="tiny-font pt-2">
      Rooms Left refers to the number of rooms left on Booking.com at the lowest rate provided. Other rooms may be available on other sites.<br />
      * Estimate Only - Please make own enquiries. Available rates are in green.<br />
      ^ Prices are per room per night, subject to availability<br />
    </section>
  </div>
</template>

<script>
import Hotel from "./Hotel";
export default {
  name: "SearchResults",
  components: {
    Hotel
  },
  props: {
    type: null,
    content: Array,
    selectedHotel: null,
    cityName: null,
    checkin: null,
    checkout: null,
    currency: null,
  },
  data() {
    return {
      translations: window.translations,
      languageCode: localStorage.getItem('locale') ?? 'en',
      languageEnUk: localStorage.getItem('locale') === 'en' ? 'us' : localStorage.getItem('locale'),
    }
  },
  methods: {
    moreBooking(more = true, hotel = null) {
      let hotelId, cityId;
      if(more) {
        if(this.selectedHotel) {
          hotelId = this.selectedHotel.booking_id;
          cityId = this.selectedHotel.city_id;
        } else {
          hotelId = this.content[0].booking_id;
          cityId = this.content[0].city_id;
        }
      } else {
        hotelId = hotel.booking_id;
        cityId = hotel.city_id;
      }

      let url = `/redirect?hotel=${hotelId}&city=${cityId}&currency=${this.currency}&language=${this.languageCode}&checkin=${this.checkin}&checkout=${this.checkout}`;
      if(more) url += '&more=1';

      window.open(url, '_blank');
    }
  }
}


</script>

<style scoped>
  .no-actual {
    opacity: 0.5;
  }
</style>
